<section class="sav-experts-page">
  <div class="sav-experts-container">
    <app-breadcrumb [items]="crumbs" />

    <!-- Left-aligned like every other page heading on the site; the previous centred hero was the
         only one of its kind. -->
    <header class="sav-experts-hero">
      <span class="sav-experts-eyebrow">SavingArena Editorial Team</span>
      <h1>Meet Our Experts</h1>
      <p>
        Our team researches promo codes, store information, deal cycles and shopping guides so
        readers can make confident savings decisions.
      </p>
    </header>

    <main class="sav-experts-main">
      <section aria-label="SavingArena experts">
        <app-section-heading
          heading="Trusted voices across SavingArena"
          subtitle="The writers and editors behind our savings guides."
        />

        <!-- Search and the result count share one row: the count is what the search changes, so
             they belong together rather than 70px apart on separate rows. -->
        <div
          class="sav-experts-toolbar"
          [attr.aria-busy]="isSearchPending() || isLoadingAuthors()"
        >
          <label class="sav-experts-search">
            <span class="sav-experts-search-label">Search experts</span>
            <svg class="sav-experts-search-icon" viewBox="0 0 24 24" aria-hidden="true">
              <path
                d="M10.5 3a7.5 7.5 0 1 1-4.62 13.41l-3.14 3.13a1 1 0 0 1-1.41-1.41l3.13-3.14A7.5 7.5 0 0 1 10.5 3Zm0 2a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11Z"
                fill="currentColor"
              ></path>
            </svg>
            <input
              type="search"
              [value]="searchTerm()"
              (input)="updateSearchTerm($event)"
              [attr.aria-busy]="isSearchPending() || isLoadingAuthors()"
              placeholder="Search by name or designation..."
            />
          </label>

          <p class="sav-experts-count" aria-live="polite">
            @if (isSearchPending() || isLoadingAuthors()) {
              <span class="sav-experts-search-spinner" aria-hidden="true"></span>
              <span>{{ isSearchPending() ? 'Searching' : 'Updating' }}</span>
              <span class="sav-experts-search-dots" aria-hidden="true">
                <span></span>
                <span></span>
                <span></span>
              </span>
            } @else {
              <span>{{ resultsLabel() }}</span>
            }
          </p>
        </div>

        @if (filteredAuthors().length) {
          <div class="sav-experts-grid" [class.is-loading]="isLoadingAuthors()">
            @for (author of filteredAuthors(); track author.slug) {
              <!-- The whole card is the link. It previously carried two buttons that both went to
                   the same profile as the card itself — thirty cards meant sixty redundant CTAs. -->
              <a
                class="sav-expert-card"
                [routerLink]="author.profilePath"
                [attr.aria-label]="author.name + ' expert profile'"
              >
                <span class="sav-expert-card-head">
                  <span class="sav-expert-card-avatar">
                    <img [src]="author.imageUrl" [alt]="author.name" loading="lazy" />
                  </span>

                  <span class="sav-expert-card-identity">
                    <span class="sav-expert-card-name">{{ author.name }}</span>
                    @if (author.role) {
                      <span class="sav-expert-card-role">{{ author.role }}</span>
                    }
                  </span>
                </span>

                <span class="sav-expert-card-bio">{{ author.bio }}</span>

                <span class="sav-expert-card-foot">
                  <span class="sav-expert-card-meta">
                    <span><strong>{{ author.articleCount }}</strong> articles</span>
                    <span aria-hidden="true">·</span>
                    <span><strong>{{ author.storesCovered }}</strong> stores</span>
                  </span>
                  <span class="sav-expert-card-cue" aria-hidden="true">View profile →</span>
                </span>
              </a>
            }
          </div>

          @if (hasPagination()) {
            <nav class="sav-experts-pagination" aria-label="Authors pagination">
              <button
                type="button"
                class="sav-experts-pagination-control"
                [disabled]="isLoadingAuthors() || currentPage() === 1"
                (click)="goToPage(currentPage() - 1)"
              >
                Previous
              </button>

              <div class="sav-experts-pagination-pages">
                @for (page of pageNumbers(); track page) {
                  <button
                    type="button"
                    class="sav-experts-pagination-page"
                    [class.is-active]="page === currentPage()"
                    [attr.aria-current]="page === currentPage() ? 'page' : null"
                    [disabled]="isLoadingAuthors()"
                    (click)="goToPage(page)"
                  >
                    {{ page }}
                  </button>
                }
              </div>

              <button
                type="button"
                class="sav-experts-pagination-control"
                [disabled]="isLoadingAuthors() || currentPage() === pagination().pages"
                (click)="goToPage(currentPage() + 1)"
              >
                Next
              </button>
            </nav>
          }
        } @else {
          <div class="sav-experts-empty">
            <h3>No experts found</h3>
            <p>Try a different name, role, or focus area.</p>
          </div>
        }
      </section>

      <section class="sav-experts-cta">
        <div>
          <span>SavingArena Guides</span>
          <h2>Want To Read More Saving Guides?</h2>
          <p>
            Read expert-backed content covering verified coupons, store policies, product deals and
            practical ways to save more online.
          </p>
        </div>
        <a [routerLink]="'/blogs'">Browse Saving Guides</a>
      </section>
    </main>
  </div>
</section>
